import * as type from "./type";

export function saveSignupCompCreateData(data){
    return{
        type : type.SAVE_SIGNUPCOMPCREATE_DATA,
        payload:data
    }
}
export function savedSignupCompCreateData(data){
    return{
        type : type.SAVED_SIGNUPCOMPCREATE_DATA,
        payload:data
    }
}
export function savedSignupCompCreateDataByEmail(data){
    return{
        type : type.SAVED_SIGNUPCOMPCREATE_DATA_BY_EMAIL,
        payload:data
    }
}
export function gettingOTPCallMain(data){
    return{
        type : type.FETCHOTPATMAILID,
        payload:data
    }
}
export function getOTPCallMainFetched(data){
    return{
        type : type.FETCHEDOTPATMAILID,
        payload:data
    }
}
export function getPasswordValidated(data){
    return{
        type : type.VALIDATINGPASSWORD,
        payload:data
    }
}
export function validatedPassword(data){
    return{
        type : type.VALIDATEDPASSWORD,
        payload:data
    }
}
export function getOTPValidated(data){
    return{
        type : type.VALIDATINGOTP,
        payload:data
    }
}
export function validatedOTP(data){
    return{
        type : type.VALIDATEDOTP,
        payload:data
    }
}
export function finalDomainCreation(data){
    return{
        type : type.FINALDOMAINCREATION,
        payload:data
    }
}
export function finalDomainCreationStatus(data){
    return{
        type : type.FINALDOMAINCREATIONSTATUS,
        payload:data
    }
}
export function checkingIfDataSaved(data){
    return{
        type : type.CHECKINGIFDATASAVED,
        payload:data
    }
}
export function checkedIfDataSaved(data){
    return{
        type : type.CHECKEDIFDATASAVED,
        payload:data
    }
}